import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Grid from '@material-ui/core/Grid';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import caaeLogo from "../../assets/images/logos/caae-logo.png";
import menuLogo from "../../assets/images/logos/caae-logo-header.png";
import Menu from "../menu";
import IconButton from '@material-ui/core/IconButton';
import { useDrawerProvider } from '../../providers/DrawerContext';
import { actions } from '../../actions/drawer';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from "@material-ui/core";
import { useMenuProvider } from '../../providers/MenuContext';

const SIDEBAR_BG = 'linear-gradient(175deg, #0d2818 0%, #174230 60%, #1a4a34 100%)';

const menuMobileBreakpoint = 'sm';

const useStyles = makeStyles((theme) => ({
    logos: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        userSelect: 'none',
    },
    caaeLogo: {
        height: drawer => drawer.openDesktop ? theme.spacing(6) : 'auto',
        width: drawer => drawer.openDesktop ? 'auto' : theme.spacing(6),
        marginRight: theme.spacing(1),
        opacity: 0.95,
        transition: 'all 0.25s ease',
    },
    toolbarInner: {
        position: 'fixed',
        zIndex: 10,
        padding: theme.spacing(2, 2.5),
        width: drawer => drawer.openDesktop ? drawer.drawerWidth : `${drawer.openDesktopWidth}px`,
        minWidth: drawer => drawer.openDesktop ? drawer.drawerWidth : `${drawer.openDesktopWidth}px`,
        backgroundColor: 'rgba(0,0,0,0.25)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(255,255,255,0.07)',
        transition: theme.transitions.create(['width', 'min-width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down('md')]: {
            width: drawer => drawer.drawerWidth,
            minWidth: 0,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    toolbarLogo: {
        width: theme.spacing(5.5),
        height: theme.spacing(5.5),
        opacity: 0.9,
    },
    toolbarCloseButton: {
        color: 'rgba(255,255,255,0.65)',
        padding: 6,
        borderRadius: 8,
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: '#ffffff',
        },
    },
    drawer: {
        height: '100%',
    },
    hiddenDrawer: {
        height: '100vh',
    },
    drawerPaper: {
        width: drawer => drawer.drawerWidth,
        minWidth: drawer => `${drawer.minDrawerWidth}px`,
        [theme.breakpoints.up(menuMobileBreakpoint)]: {
            flexShrink: 0,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        position: 'relative',
        height: '100vh',
        background: SIDEBAR_BG,
        border: 'none',
        borderRadius: 0,
        overflow: 'hidden',
    },
    drawerPaperDesktop: {
        width: drawer => drawer.openDesktop ? drawer.drawerWidth : `${drawer.openDesktopWidth}px`,
        minWidth: drawer => drawer.openDesktop ? `${drawer.minDrawerWidth}px` : 0,
        transition: theme.transitions.create(['width', 'min-width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        position: 'relative',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '100vh',
        background: SIDEBAR_BG,
        border: 'none',
        borderRadius: 0,
    },
}));

export default function SideMenu() {

    const { setCurrentRoute } = useMenuProvider();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const { state, dispatch } = useDrawerProvider();
    const classes = useStyles(state);

    const handleDrawer = () => dispatch({ type: actions.HANDLE_MENU, payload: !state.open });
    const handleDrawerDesktop = () => dispatch({ type: actions.HANDLE_MENU_DESKTOP, payload: !state.openDesktop });

    const renderMenu = () => {
        return <>
            <Grid
                className={classes.toolbarInner}
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <div className={classes.logos} onClick={matches ? handleDrawerDesktop : handleDrawer}>
                    <img className={classes.caaeLogo} src={caaeLogo} alt="CAAE" />

                </div>
                {!matches && (
                    <IconButton
                        className={classes.toolbarCloseButton}
                        onClick={handleDrawer}
                        aria-expanded={state.open}
                        aria-label="cerrar menu"
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                )}
            </Grid>
            <Menu mobileBreakpoint={menuMobileBreakpoint} updateRoute={setCurrentRoute} />
        </>
    }

    return (
        <>
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={state.open}
                    onClose={handleDrawer}
                    classes={{
                        root: classes.drawer,
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{ keepMounted: true }}
                >
                    {renderMenu()}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css" className={classes.hiddenDrawer}>
                <Drawer
                    classes={{ paper: classes.drawerPaperDesktop }}
                    variant="permanent"
                    open={state.openDesktop}
                >
                    {renderMenu()}
                </Drawer>
            </Hidden>
        </>
    );
}
